export { default as onInsuranceProfileUpdate } from './update';
export { default as onInsuranceProfileCreate } from './create';
export { default as onInsuranceProfileDelete } from './delete';
